// client/src/modules/new-year-tree-3d/product.ts
import { TreePine } from 'lucide-react';

import { defineColoringProduct } from '../../shared/coloring-kit/product';
import type { StatusTexts } from '../../shared/coloring-kit/status/StatusScreen';

import { tree3dApi } from './api';
import { TREE3D_TOY_KINDS, toyLabel } from './kinds';
import { tree3dPaths, type Tree3dWork, type Tree3dWorld } from './types';

/** Новогодняя ёлка 3D как продукт на общем ките: всё, что кит должен знать о ней, собрано здесь. */
export const tree3dProduct = defineColoringProduct<Tree3dWorld, Tree3dWork>({
  slug: 'new-year-tree-3d',
  api: tree3dApi,
  paths: tree3dPaths,
  brand: { name: 'Новогодняя ёлка 3D', tagline: 'Рисунки становятся игрушками', Icon: TreePine, bootTheme: 'winter' },
  kinds: TREE3D_TOY_KINDS.map((id) => ({ id, label: toyLabel(id) })),
});

export const TREE3D_STATUS_TEXTS: StatusTexts = {
  openFailedTitle: 'Не удалось открыть ёлку',
  unavailableEyebrow: 'Ёлка пока недоступна',
  addBlockedEyebrow: 'Игрушку сейчас не добавить',
};
